import * as React from 'react';
import { Entity } from '../utilities/Permisos';
import { Divider, FormControl, InputLabel, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { View } from '../Vistas/View';
import Common from '../utilities/common';
import $ from "jquery";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

export interface IEntityViewsProps {
    entity: Entity;
    onChange: Function;
    selectedView: string;
}

export interface IEntityViewsState {
    views: any[]
}

export default class EntityViews extends React.Component<IEntityViewsProps, IEntityViewsState> {
    _selectedView: string = "";
    public constructor(props: IEntityViewsProps) {
        super(props);

        this.state = {
            views: []
        }
    }
    componentWillReceiveProps(nextProps: Readonly<IEntityViewsProps>, nextContext: any): void {
        this._selectedView = nextProps.selectedView
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.state.views.length > 0 && (
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="labelView">Vistas</InputLabel>
                            <Select label="Vistas" defaultValue={this._selectedView == "-1" ? this.state.views[0].id : this._selectedView} labelId='labelView' onChange={(event: SelectChangeEvent) => {
                                if(event.target.value == '-666') {
                                    window.location.href = `/vistas/new?e=${this.props.entity}`;
                                }
                                else {
                                    this.props.onChange(event.target.value);
                                }
                            }}>
                                {
                                    this.state.views.map((value: View, index: number) => {
                                        return (
                                            <MenuItem value={value.id}>
                                                {
                                                    value.viewName
                                                }
                                            </MenuItem>
                                        )
                                    })
                                }
                                <Divider/>
                                <MenuItem value={-666}>
                                    <ListItemIcon>
                                        <VisibilityOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Crear vista" />
                                </MenuItem>
                                <MenuItem value={-668}>
                                    <ListItemIcon>
                                        <DeleteOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Eliminar vista" />
                                </MenuItem>
                            </Select>
                        </FormControl>
                    )
                }
            </React.Fragment>
        )
    }

    private Get(): void {
        let url = `${Common.END_POINT}/entities/${this.props.entity}/views`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    views: response
                }
            );
        }).fail(( jqXHR, textStatus, errorThrow) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
                return;
            }
        })
    }
}